module.exports = __webpack_public_path__ + "img/next_e.619b2570.svg";